import { render, staticRenderFns } from "./ParentInfo.vue?vue&type=template&id=7d7869f8&scoped=true"
import script from "./ParentInfo.vue?vue&type=script&lang=ts"
export * from "./ParentInfo.vue?vue&type=script&lang=ts"
import style0 from "./ParentInfo.vue?vue&type=style&index=0&id=7d7869f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7869f8",
  null
  
)

export default component.exports